// Estimate + Sales Order are one Quote (CEO 2026-10-15). The old project
// paths keep working — they forward to the Quotes tab / the quote itself, so
// links in sent emails, bookmarks and other screens never break.
import { Navigate, useLocation, useParams } from "react-router-dom";

export function QuotesTabRedirect() {
  const { id = "" } = useParams<{ id: string }>();
  const { search } = useLocation();
  return <Navigate to={`/projects/${id}/quotes${search}`} replace />;
}

export function QuoteDetailRedirect() {
  const { id = "", orderId = "" } = useParams<{ id: string; orderId: string }>();
  const { search, hash } = useLocation();
  return <Navigate to={`/projects/${id}/quotes/${orderId}${search}${hash}`} replace />;
}
